"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateVehicles = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs_1 = require("@ivanlog/gs");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const StateVehicle_1 = require("./StateVehicle");
class StateVehicles extends StatePaged_1.StatePaged {
    static SelectVehicle() {
        return new Promise((resolve, reject) => {
            gs_1.StateGS.Run(StateVehicles, { callbackOnSelect: resolve });
        });
    }
    constructor() {
        super(com.PageList, "Vehicles", true);
        this._includeDeleted = false;
        this._callbackOnSelect = null;
        this.page.ctrls.blockSearch.show();
        this.page.ctrls.blockFilters.show();
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateVehicle_1.StateVehicle);
        this.page.ctrls.btnSearch.onclick = () => this.trySearch();
        this.page.ctrls.taSearch.el.placeholder = "Search vehicles";
        this._setupFilters();
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.CompanyControl))
            this.page.ctrls.btnNew.hide();
    }
    start(arg) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (arg) {
                if (arg.search) {
                    this.page.ctrls.taSearch.value = arg.search;
                    yield this.trySearch();
                    return _super.start.call(this);
                }
                this._callbackOnSelect = arg.callbackOnSelect;
                if (this._callbackOnSelect)
                    this.title = "Select vehicle:";
            }
            const vehicles = yield this.lockgui(this.app.api.admin.directory.getVehicles(0, this._includeDeleted));
            if (!vehicles)
                return gs_1.StateRunResultEnum.Failed;
            yield this.fill(vehicles);
            return _super.start.call(this);
        });
    }
    fill(vehicles) {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.list.html = "";
            for (const vehicle of vehicles) {
                const vt = yield this.app.astra.getVehiclesType(vehicle.vehicleTypeId);
                const item = new com.ListItem();
                item.ctrls.lType.text = vehicle.isDeleted
                    ? "Vehicle (deleted)"
                    : "Vehicle";
                item.ctrls.lId.text = `#${vehicle.id}`;
                const typeLabel = vt
                    ? this._formatVehicleTypeLabel(vt)
                    : `#${vehicle.vehicleTypeId}`;
                const data = [
                    gs.text.clearHtmlToText(`Type: ${typeLabel}`),
                    gs.text.clearHtmlToText(`Model: ${vehicle.model}`),
                    gs.text.clearHtmlToText(`Gov.number: ${vehicle.govNumber}`),
                ];
                item.ctrls.pData.html = data.join("<br>");
                this.page.ctrls.list.append(item);
                if (this._callbackOnSelect)
                    item.onclick = () => this._callbackOnSelect(vehicle);
                else if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.VehicleControl))
                    item.onclick = () => gs_1.StateGS.Run(StateVehicle_1.StateVehicle, vehicle);
                else
                    item.onclick = () => new modalCom.DialogOk(gs.helpers.text.replaceAll(vehicle.vehicleData, "\n", "<br>"), "Vehicle information").show();
            }
        });
    }
    trySearch() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = this.page.ctrls.taSearch.value;
            if (!data)
                return;
            const vehicles = yield this.lockgui(this.app.api.admin.directory.searchVehicles(data));
            if (!vehicles)
                return;
            const filtered = this._includeDeleted
                ? vehicles
                : vehicles.filter((v) => !v.isDeleted);
            yield this.fill(filtered);
            this._urlArgs["search"] = decodeURI(data);
            this.updateUrl();
        });
    }
    _setupFilters() {
        if (this.page.ctrls.labelFilter)
            this.page.ctrls.labelFilter.text = "Show";
        const select = this._getFilterElement();
        if (!select)
            return;
        select.innerHTML = "";
        select.append(new Option("Active only", "active"));
        select.append(new Option("All vehicles", "all"));
        select.value = this._includeDeleted ? "all" : "active";
        select.onchange = () => __awaiter(this, void 0, void 0, function* () {
            this._includeDeleted = select.value === "all";
            const currentSearch = this.page.ctrls.taSearch.value;
            if (currentSearch) {
                yield this.trySearch();
                return;
            }
            const vehicles = yield this.lockgui(this.app.api.admin.directory.getVehicles(0, this._includeDeleted));
            if (vehicles)
                yield this.fill(vehicles);
        });
    }
    _getFilterElement() {
        var _a;
        const element = (_a = this.page.ctrls.selectFilter) === null || _a === void 0 ? void 0 : _a.el;
        return element instanceof HTMLSelectElement ? element : null;
    }
    _formatVehicleTypeLabel(vtype) {
        if (!vtype)
            return "Unknown";
        const parts = [];
        if (vtype.sizeClass)
            parts.push(vtype.sizeClass);
        if (vtype.size)
            parts.push(`w${vtype.size.width} : l${vtype.size.length} : h${vtype.size.height}`);
        const summary = parts.filter(Boolean).join(" | ");
        return summary || `#${vtype.id}`;
    }
}
exports.StateVehicles = StateVehicles;
StateVehicles.StateName = "vehicles";
//# sourceMappingURL=StateVehicles.js.map